
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { default as ColourPicker } from '@/shared/services/color';

@Component
export default class ConversationHeader extends Vue {

	@Prop() public brandColour: string;
	@Prop() public outboundMessageColour: string;
	@Prop() public headerText: string;
	@Prop() public subtitleText: string;

	public getContrastingBrandColour() {
		return ColourPicker.getContrastingColour(this.brandColour);
	}

	public getContrastingSentMessageColour() {
		return ColourPicker.getContrastingColour(this.outboundMessageColour);
	}

	private getDarkHeader() {
		return ColourPicker.darken(this.brandColour, 12);
	}
}
